/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-arrow-function-lifecycle */
/* eslint-disable padding-line-between-statements */
import { Loader, withModalContext } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { ServiceManager } from '@jutro/legacy/services';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';
import {
    validationDefaultProps,
    validationPropTypes,
    withValidation,
} from '@xengage/gw-portals-validation-react';
import {
    ViewModelForm,
    withViewModelService,
    
} from '@xengage/gw-portals-viewmodel-react';
import { OrganizationService, UserService } from 'gw-capability-gateway';
import { AccountService } from 'gw-capability-gateway-policy';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import StandardAddressValidationUtil from 'twia-capability-address-component/util/StandardAddressValidationUtil';
import gatewayMessages from '../../gateway.messages';
import messages from '../NewQuoteAccountSearch.messages';
import pageMessages from './NewQuotePage.messages';
import metadata from './NewQuotePage.metadata.json5';
import styles from './NewQuotePage.module.scss';
import NewSubmissionPage from './NewSubmission/NewSubmissionPage';

class NewQuotePage extends Component {
    static contextType = TranslatorContext;

    state = {
        submissionVM: {},
        producerCode: [],
        isAnExistingAccount: false,
        accountHolderDetails: {},
        accountHolderViewVM: {},
        newAccountCreate: {},
        allOrganisationValue: [],
        selectedOrganisationValue: '',
        showErrors: false,
        isLoading: true,
        emailValidationMessages : [],
        producerCodes: [],
        dateValidationMsg : [],
        validatingEmail: false
    };

    static propTypes = {
        viewModelService: PropTypes.shape({
            create: PropTypes.func,
        }).isRequired,
        location: PropTypes.shape({
            state: PropTypes.shape({
                accountSearchCriteria: PropTypes.object,
            }),
        }).isRequired,
        match: PropTypes.shape({
            params: PropTypes.shape({
                accountNumber: PropTypes.string,
            }),
        }).isRequired,
        authHeader: PropTypes.shape({
            Authorization: PropTypes.string,
        }).isRequired,
        authUserData: PropTypes.shape({}),
        history: PropTypes.shape({
            push: PropTypes.func,
        }).isRequired,
        ...validationPropTypes,
    };

    static defaultProps = {
        authUserData: undefined,
        ...validationDefaultProps,
    };

    localeService = ServiceManager.getService('locale-service');

    componentDidUpdate(prevProps) {
        const { authUserData } = this.props;

        if (
            _.get(prevProps, 'authUserData.userType') !==
            _.get(authUserData, 'userType')
        ) {
            this.getAccountHolderDetails();
        }
    }

      
    updateAccountHolderVM = accountHolderViewVM => {
        this.setState({ accountHolderViewVM });
    };

    userIsAgent = () => {
        const { authUserData } = this.props;
        
        return _.get(authUserData, 'userType') === 'producer';
    };

    getProducerCodes = () => {
        let { producerCode } = this.state;
        let { producerCodes } = this.state;
        const { authHeader } = this.props;

        UserService.getAvailableProducerCodesForCurrentUser(authHeader).then(
            producerCodeResponse => {
                if(producerCodeResponse?.length === 1){
                    producerCode = _.sortBy(producerCodeResponse, 'code').map(
                        value => ({
                                code: value.code,
                                name: `${value.displayValue}`,
                            })
                    );
                    this.setState({producerCode})
                }else {
                    producerCodes = _.sortBy(producerCodeResponse, 'code').map(
                        value => ({
                                code: value.code,
                                name: `${value.displayValue}`,
                            })
                    );
                    this.setState({producerCodes})
                }   
            }
        );
    };

    getAccountHolderDetails = async () => {
        let isAnExistingAccount;
        const {
            match: {
                params: { accountNumber },
            },
        } = this.props;

        if (accountNumber) {
            await this.findAccount(accountNumber);
            isAnExistingAccount = true;
        } else {
            const { accountHolderDetails } = this.state;
            const { location, history } = this.props;
            const accountSearchCriteria = _.get(
                location,
                'state.accountSearchCriteria'
            );
            const accountHolder = {
                contactName: '',
                primaryAddress: {},
            };

            if (_.isNil(accountSearchCriteria)) {
                history.push('/');

                return;
            }

            isAnExistingAccount = false;

            const criteriaContactType = accountSearchCriteria.contactType;

            accountHolderDetails.contactType =
                _.upperFirst(criteriaContactType);

            if (accountHolderDetails.contactType === 'Person') {
                accountHolder.firstName = accountSearchCriteria.firstName;
                accountHolder.lastName = accountSearchCriteria.lastName;

                if (accountSearchCriteria.lastNameKanji) {
                    accountHolder.firstNameKanji =
                        accountSearchCriteria.firstNameKanji;
                    accountHolder.lastNameKanji =
                        accountSearchCriteria.lastNameKanji;
                }
            } else {
                accountHolder.contactName = accountSearchCriteria.contactName;

                if (accountSearchCriteria.contactNameKanji) {
                    accountHolder.contactNameKanji =
                        accountSearchCriteria.contactNameKanji;
                }
            }

            accountHolder.primaryAddress.city = accountSearchCriteria.city;
            accountHolder.primaryAddress.state = accountSearchCriteria.state;
            accountHolder.primaryAddress.postalCode =
                accountSearchCriteria.postalCode;
            accountHolder.primaryAddress.country =
                accountSearchCriteria.country;

            if (accountSearchCriteria.cityKanji) {
                accountHolder.primaryAddress.cityKanji =
                    accountSearchCriteria.cityKanji;
            }

            this.setState(
                {
                    accountHolderDetails,
                },
                () => {
                    this.setAccountHolderViewVM(accountHolder);
                }
            );

            accountSearchCriteria.contactName = '';
            accountSearchCriteria.lastName = '';
            accountSearchCriteria.firstName = '';
            accountSearchCriteria.city = '';
            accountSearchCriteria.state = '';
            accountSearchCriteria.postalCode = '';
        }

        if (this.userIsAgent()) {
            this.getProducerCodes();
        } else {
            this.getAllOrganisation();
        }

        this.setState({
            isLoading: false,
            isAnExistingAccount,
        });
    };

    getAllOrganisation = () => {
        const { authHeader } = this.props;
        let { allOrganisationValue } = this.state;

        OrganizationService.getAvailableOrganizations(authHeader).then(
            getOrganizationsResponse => {
                allOrganisationValue = getOrganizationsResponse.map(value => ({
                        code: `${value.publicID}`,
                        name: `${value.displayName}`,
                    }));

                this.setState({
                    allOrganisationValue,
                });
            }
        );
    };

    handleValueOrganisation = value => {
        let { selectedOrganisationValue } = this.state;

        selectedOrganisationValue = value;
        this.getProducerCodesForAnOrganization(value);
        this.setState({ selectedOrganisationValue });
    };

    getProducerCodesForAnOrganization = selectedOrganisationValue => {
        let { producerCode } = this.state;
        const { accountHolderViewVM, allOrganisationValue } = this.state;
        const { authHeader } = this.props;
        let organisationCode = {};

        const selectedOrganisation = selectedOrganisationValue;

        allOrganisationValue.forEach(value => {
            if (value.code === selectedOrganisation) {
                organisationCode = {
                    displayName: value.name,
                    publicID: value.code,
                };
            }
        });
        OrganizationService.getProducerCodeForOrganization(
            organisationCode,
            authHeader
        ).then(producerCodeResponse => {
            producerCode = producerCodeResponse.map(value => ({
                    code: value.code,
                    name: value.displayValue,
                }));
            _.set(accountHolderViewVM, 'producerCode', '');
            this.setState({
                producerCode,
                accountHolderViewVM,
            });
        });
    };

    getCountyTypeList = () => {
        const countyTypelist = this.props.viewModelService?.productMetadata?.get('pc').types.getTypelist('County_TWIA');
        const formattedTypes =  countyTypelist?.codes.filter(code => code.code !== "default").map((code) => {
        // DE18383, DE18417
            const translator = this.context;
            const formatedCode = {
                code: code.code,
                name: translator({
                    id: code.name,
                })
            }

            return formatedCode
        })

        return formattedTypes
    };

    getCityTypeList = (selectedCounty) => {
        if(!selectedCounty){
            return []
        }
        const selectedCountyCode = this.props.viewModelService?.productMetadata?.get('pc').types.getTypelist('County_TWIA')?.getCode(selectedCounty);
       
        const cityTypelist = this.props.viewModelService?.productMetadata?.get('pc').types.getTypelist('City_TWIA')?.getCodesForCategory(selectedCountyCode);
        const translator = this.context;
   
       
        const formattedTypes =  cityTypelist?.filter(code => code.code !== "default").map((code) => {
            const formatedCode = {
                code: code.code,
                name: translator({
                    id: code.name,
                })
            }

            return formatedCode
        })

        return formattedTypes
    };

    getZipCodeTypeList = (selectedCity, isTWIA) => {
        if(!isTWIA && selectedCity){
            return []
        }

        if(!selectedCity){
            return []
        }

        const selectedCityCode = this.props.viewModelService?.productMetadata?.get('pc').types.getTypelist('City_TWIA')?.getCode(selectedCity);
       
        const zipCodeTypelist = this.props.viewModelService?.productMetadata?.get('pc').types.getTypelist('PostalCode_TWIA')?.getCodesForCategory(selectedCityCode);
        const translator = this.context;
   
       
        const formattedTypes =  zipCodeTypelist?.filter(code => code.code !== "default").map((code) => {
            const formatedCode = {
                code:  translator({
                    id: code.name,
                }),
                name: translator({
                    id: code.name,
                })
            }

            return formatedCode
        })

        return formattedTypes
    };

    componentDidMount = async () => {
        let { submissionVM } = this.state;
        const { viewModelService } = this.props;
        const model = {
            country: this.localeService.getDefaultCountryCode(),
        };

        submissionVM = viewModelService.create(
            model,
            'pc',
            'edge.capabilities.gateway.job.submission.dto.NewSubmissionDTO'
        );
        
        _.set(submissionVM, 'effectiveDate', LocalDateUtil.today());
        _.set(submissionVM, 'productCode', '');
        this.setState(
            {
                submissionVM,
            },
            () => {
                this.getAccountHolderDetails();
            }
        );
    };

    findAccount = async accountNumber => {
        const { accountHolderDetails, submissionVM } = this.state;
        const { authHeader, modalContext } = this.props;
        const account = await AccountService.getAccountDetails(
            accountNumber,
            authHeader
        );
        const texasStateCode = this.props.viewModelService?.productMetadata?.get('pc').types.getTypelist('State')?.getCode('TX');
        const usCountryCode = this.props.viewModelService?.productMetadata.get('pc').types.getTypelist('typekey.Country').getCode('US');
        if (account.accountHolder) {
            accountHolderDetails.contactType = account.accountHolder.subtype;
            accountHolderDetails.newAccount = account;

            // 2025-11-12 - Debra Frum - DE19606 - PE - TFPA : Unable to create future dated policy past 30 days even after changing 
            //   the script parameter
            // Replace hard-coded frontend max effective date validation with use of backend DTO validation which uses script parameters 
            // to define the max effective days in the future for each Association
            //
            // Set new Association field added to DTO to validate that the effective date is within range for the Association
            _.set(
                submissionVM,
                'associationName_TWIA',
                accountHolderDetails.newAccount.accountHolder.associationName_Ext
            );

            _.set(
                submissionVM,
                'state',
                texasStateCode.code
            );
            // Fix for - When country was non-US then it was not getting updated
            _.set(
                submissionVM,
                'country',
                usCountryCode.code
            );
            accountHolderDetails.displayAddressArray =
                account.accountHolder.primaryAddress.displayName
                    .split(', ')
                    .join('\n');

            _.set(submissionVM, 'accountNumber', account.accountNumber);
            _.set(submissionVM, 'producerCode', account.producerCodes[0].code);
            _.set(submissionVM, 'accountPublicId', account.publicID);
        } else {
            modalContext
                .showConfirm({
                    title: gatewayMessages.modelError,
                    message: messages.accountTypeErrorMessage,
                    status: 'warning',
                    icon: 'mi-error-outline',
                })
                .then(results => {
                    if (results === 'cancel' || results === 'close') {
                        return _.noop();
                    }

                    return window.history.back();
                }, _.noop);
        }

        this.setState(
            {
                accountHolderDetails,
                submissionVM,
            },
            () => {
                this.setAccountHolderViewVM(accountHolderDetails.newAccount);
            }
        );
    };

    setAccountHolderViewVM = account => {
        const { viewModelService } = this.props;
        let { accountHolderViewVM } = this.state;
        const { accountHolderDetails } = this.state;
        const viewModel = viewModelService.create(
            account,
            'pc',
            'edge.capabilities.policycommon.accountcontact.dto.AccountContactDTO',
            {   // US26284: PE - Common Quote - New Account - Policyholder Details : The requiredness of producer code is handled in the overrides
                ProducerCodeRequired: false,
            }
        );

        _.set(viewModel, 'isAgentPortalContact', true);

        if (accountHolderDetails.contactType === 'Person') {
            _.set(viewModel, 'subtype.value', 'Person');
        } else {
            _.set(viewModel, 'subtype.value', 'Company');
        }

        accountHolderViewVM = viewModel;
        this.setState({
            accountHolderViewVM,
        });
    };

    createNewAccount = async () => {
        const {
            accountHolderDetails,
            newAccountCreate,
            accountHolderViewVM,
            submissionVM,
            modalContext,
        } = this.state;
        const { authHeader, history } = this.props;
        const isTWIA = this.props?.authUserData?.associationName_TWIA === 'twia'
        let { isAnExistingAccount } = this.state;
        const translator = this.context;
        const newAccount = {
            accountHolder: {
                primaryAddress: {
                    addressType: 'business',
                },
            },
        };

        newAccount.accountHolder = _.get(accountHolderViewVM, 'value');

        if (accountHolderDetails.contactType === 'Person') {
            newAccount.accountHolder.contactName = `${accountHolderViewVM.firstName.value} ${accountHolderViewVM.lastName.value}`;
            newAccount.accountHolder.primaryAddress.addressType = 'home';
        }

        newAccount.producerCodes = [
            {
                code: _.get(accountHolderViewVM, 'producerCode.value'),
            },
        ];

        // DE18383, DE18417
        const county = _.get(accountHolderViewVM, 'primaryAddress.county.value');

        if (isTWIA) {
            const city = _.get(accountHolderViewVM, 'primaryAddress.cityTWIA');
            const selectedCityCode = this.props.viewModelService?.productMetadata?.get('pc').types.getTypelist('City_TWIA')?.getCode(city);         
            const selectedCountyCode = this.props.viewModelService?.productMetadata?.get('pc').types.getTypelist('County_TWIA')?.getCode(county);
            _.set(newAccount, 'accountHolder.primaryAddress.city', translator({id: selectedCityCode.name }))
            _.set(newAccount, 'accountHolder.primaryAddress.county', translator({id: selectedCountyCode.name }))
        }        

        const newAccountResponse = await AccountService.getOrCreateAccount(
            newAccount,
            authHeader
        );

        if (newAccountResponse.accountNumber) {
            newAccountCreate.newAccount = newAccountResponse;
            newAccountCreate.displayAddressArray =
                newAccountResponse.accountHolder.primaryAddress.displayName
                    .split(', ')
                    .join('\n');

            _.set(
                submissionVM,
                'accountNumber',
                newAccountResponse.accountNumber
            );

            _.set(
                accountHolderViewVM,
                'primaryAddress.county.value',
                county
            );

            _.set(
                submissionVM,
                'producerCode',
                newAccount.accountHolder.producerCode
            );
            
            isAnExistingAccount = true;
        } else {
            modalContext
                .showConfirm({
                    title: messages.accountTypeError,
                    message: messages.newAccountCreateErrorMessage,
                    status: 'warning',
                    icon: 'mi-error-outline',
                })
                .then(results => {
                    if (results === 'cancel' || results === 'close') {
                        return _.noop();
                    }

                    return window.history.back();
                }, _.noop);
        }

        this.setState(
            {
                newAccountCreate,
                isAnExistingAccount,
                submissionVM,
            },
            () => history.push(
                    `/new-quote/${_.get(submissionVM, 'accountNumber.value')}`
                )
        );
    };

    handleValidation = () => {
        this.setState({ showErrors: true });
    };

    handleCancel = () => {
        const { history, modalContext } = this.props;

        modalContext
            .showConfirm({
                title: messages.cancelQuote,
                message: messages.cancelMessageSubmission,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.yes,
                cancelButtonText: commonMessages.noModel,
            })
            .then(results => {
                if (results === 'cancel' || results === 'close') {
                    return _.noop();
                }

                return history.push('/accounts');
            }, _.noop);
    };

    updateSubmission = submissionVM => {
        this.setState({
            submissionVM,
        });
    };

    TWIAEmailValidation =  async (event ,fullValue) =>{
        let emailValidationMessages = [];
        const translator = this.context;
        const {authHeader} = this.props; 
        // const isTWIA = this.props?.authUserData?.associationName_TWIA === 'twia'
        const {accountHolderViewVM} = this.state;
        const { model, value } = fullValue;

        this.setState({emailValidationMessages})
        _.set(accountHolderViewVM, model, value);

        this.setState({ accountHolderViewVM });

        // setting validation message for both TFPA/TWIA
        try{
            // trim all spaces around the email
            if (fullValue.value.substring(0, fullValue.value.length).includes(' ')){
                emailValidationMessages = [translator(pageMessages.mustBeValidEmailAddress)];
                this.setState({emailValidationMessages});
                return;
            }

            if (! _.get(accountHolderViewVM, `${model}.aspects.valid`)) {
                emailValidationMessages = [translator(pageMessages.mustBeValidEmailAddress)];
                this.setState({emailValidationMessages});
                return;
            }

            const isProducer = await  OrganizationService.isProducerEmail_TWIA(value, authHeader)
            
            if (isProducer) {
                emailValidationMessages = [translator(pageMessages.TWIAProducerEmailError)];
                this.setState({emailValidationMessages});
            } else {
                this.setState({ validatingEmail: false });
            }

        }catch(err){
            console.error(err);
            this.setState({ validatingEmail: false });
        }
    }

    checkDOBValidity = async (event ,fullValue) => { // DE18410
        let dateValidationMsg = [];
        const translator = this.context;
        const { value } = fullValue;

        this.setState({dateValidationMsg})
        if (_.isUndefined(value)) {
            dateValidationMsg = [translator(messages.dateMustmatch)]
            this.setState({dateValidationMsg});
        }
    };

    handleEmailChange = (value, path) => {
        const { accountHolderViewVM } = this.state;
        _.set(accountHolderViewVM, path, value);
        this.setState({ ...this.state, accountHolderViewVM, validatingEmail: true });
    };

    /**
     * DE19540: TWIA - Default City for Brazoria and Galveston
     * based off of AddressDetails.jsx
     * @param {*} value 
     * @param {*} path 
     */
    writeValue = (value, path) => {
        const { accountHolderViewVM } = this.state;

        _.set(accountHolderViewVM, path, value);
               
        if(_.includes(path, 'county')){
            // DE15598
            const sameNameCity = _.find(this.getCityTypeList(value), (_city)=>{
                return _city.name.replace(/\s/g, "") === value
            })

            if(sameNameCity){
                _.set(accountHolderViewVM?.primaryAddress, 'cityTWIA', sameNameCity?.code);
            }else{
                _.set(accountHolderViewVM?.primaryAddress, 'cityTWIA', undefined);
            }

            _.set(accountHolderViewVM?.primaryAddress, 'postalCode.value', undefined);
        }

        if(_.includes(path, 'cityTWIA')){
            _.set(accountHolderViewVM?.primaryAddress, 'postalCode.value', undefined);
        }    
    };

    render() {
        const {
            accountHolderViewVM,
            accountHolderDetails,
            isAnExistingAccount,
            submissionVM,
            newAccountCreate,
            allOrganisationValue,
            selectedOrganisationValue,
            showErrors,
            isLoading,
            emailValidationMessages,
            dateValidationMsg,
            validatingEmail
        } = this.state;
        const isAgent = this.userIsAgent();
        const { producerCode } = this.state;
        const translator = this.context;
        const { setComponentValidation, isComponentValid } =
            this.props;
        const associationName = this.props.authUserData.associationName_TWIA;
        const selectedCounty = accountHolderViewVM?.primaryAddress?.county?.value || false;
        const selectedCity = accountHolderViewVM?.primaryAddress?.cityTWIA || false;
         
        
        // DE17385
        if(accountHolderViewVM?.primaryAddress?.state){
            accountHolderViewVM.primaryAddress.state = 'TX';
            StandardAddressValidationUtil.setOverridden(accountHolderViewVM.primaryAddress.value);
        }
     
        if(accountHolderViewVM?.producerCode && producerCode.length === 1){
            _.set(accountHolderViewVM, 'producerCode', producerCode[0].code) 
        }
        
        let contactTypeValue = '';
        let subTypeLabel = '';
        if(associationName === 'twia') {
            if (_.get(accountHolderViewVM, 'subtype.value') === 'Person') {
                contactTypeValue = translator(messages.contactTypePersonal);
                subTypeLabel = translator(messages.name);
            } else if (_.get(accountHolderViewVM, 'subtype.value') === 'Company') {
                contactTypeValue = translator(messages.contactTypeOrganization);
                subTypeLabel = translator(messages.organizationName);
            }
        } else if (associationName === 'tfpa') {
            if (_.get(accountHolderViewVM, 'subtype.value') === 'Person') {
                contactTypeValue = translator(messages.contactTypeIndividual);
                subTypeLabel = translator(messages.name);
            } else if (_.get(accountHolderViewVM, 'subtype.value') === 'Company') {
                contactTypeValue = translator(messages.contactTypeEstate);
                subTypeLabel = translator(messages.organizationName);
            }
        }
        const isTWIA = associationName === "twia";

    

        const accountType = !!(
            _.get(accountHolderViewVM, 'subtype') &&
            _.get(accountHolderViewVM, 'subtype.value') === 'Person'
        );
        const overrideProps = {
            '@field': {
                labelPosition: 'left',
                showRequired: true,
            },
            newQuoteDetailsContainer: {
                visible: !isAnExistingAccount,
            },
            policyDetailsContainer: {
                visible: isAnExistingAccount,
            },
            dateOfBirth:{
                visible: !isTWIA,
                onBlur: this.checkDOBValidity, // DE18410
                validationMessages: dateValidationMsg
            },
            email:{
                required: !isTWIA,
                onBlur:  this.TWIAEmailValidation,
                validationMessages:  emailValidationMessages,
                onValueChange: this.handleEmailChange
            },
            // DE15851 Should be available when association is TWIA
            emailNotification: {
                visible : associationName === 'twia'
            },
            commercialContainer: {
                visible: !accountType,
            },
            personalContainer: {
                visible: accountType,
            },
            producerCode: {
                required: true,
                availableValues: this.state.producerCode.length > 0 ? this.state.producerCode : this.state.producerCodes ,
            },
            accountState:{
                readOnly: true,
                value: 'TX',   
            },
            postalCode:{
                visible: !isTWIA
            },
            city:{
                visible: !isTWIA,
                required: true
            },
            postalCodeTWIA:{
                visible: isTWIA,
                // eslint-disable-next-line no-unneeded-ternary
                disabled: selectedCity ? false : true,
                availableValues: this.getZipCodeTypeList(selectedCity, isTWIA)
            },
            cityTWIA:{
                visible: isTWIA,
                required: isTWIA && selectedCounty, // DE15853
                // eslint-disable-next-line no-unneeded-ternary
                disabled: selectedCounty ? false : true,
                availableValues: this.getCityTypeList(selectedCounty)
            },
            countyTWIA:{
                visible: isTWIA,
                required: true,
                availableValues: this.getCountyTypeList()
            },
            contactType: {
                value: contactTypeValue,
            },
            organisation: {
                availableValues: allOrganisationValue,
                onValueChange: this.handleValueOrganisation,
                value: selectedOrganisationValue,
            },
            addressDetails: {
                label: subTypeLabel,
                // DE15804 do not display address for TFPA
                value: _.get(newAccountCreate, 'displayAddressArray')
                        ? _.get(
                            newAccountCreate,
                            'newAccount.accountHolder.displayName')
                        : _.get(
                            accountHolderDetails,
                            'newAccount.accountHolder.displayName'
                        )
            },
            accountNumberDetails: {
                value: _.get(submissionVM, 'accountNumber.value'),
            },
            contactTypeDetails: {
                value: contactTypeValue,
            },
            existingAccountDiv: {
                visible: isAnExistingAccount,
            },
            newSubmission: {
                ...this.props,
                visible: isAnExistingAccount,
                isAnExistingAccount,
                submissionVM,
                postalCode:
                    _.get(
                        newAccountCreate.newAccount,
                        'accountHolder.primaryAddress.postalCode'
                    ) ||
                    _.get(
                        accountHolderDetails.newAccount,
                        'accountHolder.primaryAddress.postalCode'
                    ),
                selectedProducerCode: // DE17827
                    _.get(
                        newAccountCreate.newAccount,
                        'producerCodes'
                    ) ||
                    _.get(
                        accountHolderDetails.newAccount,
                        'producerCodes'
                    ),
                updateSubmissionVM: this.updateSubmission,
                producerCodeValue: isAgent ? this.state.producerCode.length > 0 ? this.state.producerCode : this.state.producerCodes : [],
                isAgent,
                allOrganisationValue
            },
            next: {
                disabled: validatingEmail
            }
        };

        



        const resolvers = {
            resolveClassNameMap: styles,
            resolveComponentMap: {
                newsubmission: NewSubmissionPage,
            },
            resolveCallbackMap: {
                submitCreateAccountForm: isComponentValid
                    ? this.createNewAccount
                    : this.handleValidation,
                onCancel: this.handleCancel,
            },
        };

        if (isLoading) {
            return <Loader loaded={!isLoading} />;
        }

        const readValue = (id, path) => readViewModelValue(
                metadata.pageContent,
                accountHolderViewVM,
                id,
                path,
                overrideProps
            );

        return (
            <div>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={accountHolderViewVM}
                    onModelChange={this.updateAccountHolderVM}
                    overrideProps={overrideProps}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                    classNameMap={resolvers.resolveClassNameMap}
                    onValueChange={this.writeValue}
                    onValidationChange={setComponentValidation}
                    resolveValue={readValue}
                    showErrors={showErrors}
                />
            </div>
        );
    }
}
export const NewQuoteComponent = withModalContext(NewQuotePage);
export default withValidation(
    withRouter(
        withViewModelService(
            withAuthenticationContext(withModalContext(NewQuotePage))
        )
    )
);
